/** MUI v4 breakpoint helpers (xs <600, sm 600–959, md 960+) */

export function isMobileWidth(width) {
    return width === 'xs' || width === 'sm';
}
